// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Random = require("../Effect.Random/index.js");
var Sudoku_Internal = require("../Sudoku.Internal/index.js");
var Sudoku_Internal_Generator = require("../Sudoku.Internal.Generator/index.js");
var Sudoku_Internal_Solver = require("../Sudoku.Internal.Solver/index.js");
var Sudoku_Wordlist = require("../Sudoku.Wordlist/index.js");
var randomWord = function (v) {
    return Data_Functor.map(Effect.functorEffect)((function () {
        var $2 = Data_Maybe.fromMaybe("");
        var $3 = Data_Array.index(Sudoku_Wordlist.wordlist);
        return function ($4) {
            return $2($3($4));
        };
    })())(Effect_Random.randomInt(0)(Data_Array.length(Sudoku_Wordlist.wordlist) - 1 | 0));
};
var generate = function (opts) {
    var wordMap = function (word) {
        return function (sudoku) {
            var solved = Data_Maybe.fromMaybe(sudoku)(Data_Functor.map(Data_Maybe.functorMaybe)(Sudoku_Internal.gridString)(Sudoku_Internal_Solver.solve(Sudoku_Internal.UniqueDiagonal.value)(Data_Maybe.fromMaybe([  ])(Data_Either.hush(Sudoku_Internal.readNumberGrid(sudoku))))));
            return Data_Map_Internal.fromFoldable(Data_Ord.ordChar)(Data_Foldable.foldableArray)(Data_Array.zip(Data_String_CodeUnits.toCharArray(Sudoku_Internal.diagonalOf(solved)))(Data_String_CodeUnits.toCharArray(word)));
        };
    };
    var mapValues = function (m) {
        return function (str) {
            return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (s) {
                return function (c) {
                    return s + Data_String_CodeUnits.singleton(Data_Maybe.fromMaybe(".")(Data_Map_Internal.lookup(Data_Ord.ordChar)(c)(m)));
                };
            })("")(Data_String_CodeUnits.toCharArray(str));
        };
    };
    var game = function (opts1) {
        return Sudoku_Internal_Generator.generateSudoku(opts1.variant)(opts1.difficulty);
    };
    if (opts.values instanceof Sudoku_Internal_Generator.Sudoku) {
        return game(opts);
    };
    if (opts.values instanceof Sudoku_Internal_Generator.Colorku) {
        return Data_Functor.map(Effect.functorEffect)(mapValues(Data_Map_Internal.fromFoldable(Data_Ord.ordChar)(Data_Foldable.foldableArray)(Data_Array.zip(Sudoku_Internal_Generator.numChars)(Sudoku_Internal_Generator.colorChars))))(game(opts));
    };
    if (opts.values instanceof Sudoku_Internal_Generator.Wordoku) {
        return function __do() {
            var g = game(opts)();
            var w = randomWord(Data_Unit.unit)();
            return mapValues(wordMap(w)(g))(g);
        };
    };
    throw new Error("Failed pattern match at Sudoku.Generator (line 28, column 17 - line 34, column 41): " + [ opts.values.constructor.name ]);
};
module.exports = {
    generate: generate,
    randomWord: randomWord
};
